import { useRef, useState } from 'react';
import uploadDocumentRequest from '../../../services/uploadDocument.service';
import { getBase64 } from '../../../shared/utils/utils';

export default function useCameraInputHook({
  hotelId,
  field,
  checkinGuestId,
  setCurrentFormValue,
}) {
  const [state, setState] = useState({
    loading: false,
    showCameraModal: false,
    imageUrl: null,
    file: null,
  });

  const streamRef = useRef();

  const actions = {
    setShowCameraModal: show => {
      if (!show) {
        if (streamRef.current) {
          try {
            streamRef.current.getTracks().forEach(function (track) {
              track.stop();
            });
          } catch (e) {}
        }
      }
      updateState({ showCameraModal: show });
    },

    handleCameraChange: data => {
      const file = new File([data], 'document-' + new Date().getTime() + '.jpeg', {
        type: 'image/jpeg',
      });

      getBase64(data, imageUrl => {
        updateState({
          loading: false,
          imageUrl,
          file,
        });
      });
    },

    onSaveImage: () => {
      if (state.file) {
        updateState({ loading: true });
        actions.uploadAdditionalDocument(state.file);
      }
    },

    onRetakeImage: () => {
      updateState({ imageUrl: null, file: null });
    },

    uploadAdditionalDocument: file => {
      uploadDocumentRequest(hotelId, {
        file,
        type: field.key,
        checkinGuestId: checkinGuestId,
      })
        .then(_res => {
          actions.setShowCameraModal(false);

          updateState({ loading: false });
          setCurrentFormValue(field.key, file.name);
        })
        .catch(error => {
          updateState({ loading: false, imageUrl: null });
        });
    },

    setStreamRef: ref => {
      streamRef.current = ref;
    },
  };

  function updateState(object) {
    setState(previousState => ({ ...previousState, ...object }));
  }

  return { state, actions };
}
